export default {
  example: {
    test: '語言測試'
  },
  placeholder: {
    select: '請選擇',
    input: '請輸入',
    upload: '請上傳'
  },
  correct: {
    email: '請輸入正確的電郵',
    phone: '請輸入正確的手機號碼',
  }
}